__turbopack_context__.v({
  "card": "styles-module-scss-module__ZPdAxq__card",
  "company_heading": "styles-module-scss-module__ZPdAxq__company_heading",
  "contact_content": "styles-module-scss-module__ZPdAxq__contact_content",
  "contact_link": "styles-module-scss-module__ZPdAxq__contact_link",
  "image_container": "styles-module-scss-module__ZPdAxq__image_container",
  "inner_content": "styles-module-scss-module__ZPdAxq__inner_content",
  "inner_content_container": "styles-module-scss-module__ZPdAxq__inner_content_container",
  "name_heading": "styles-module-scss-module__ZPdAxq__name_heading",
  "no_contact": "styles-module-scss-module__ZPdAxq__no_contact",
  "no_image": "styles-module-scss-module__ZPdAxq__no_image",
  "title_heading": "styles-module-scss-module__ZPdAxq__title_heading",
});
